/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Table, Input, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import usePaginationHook from '../../../../utils/usePagination';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import fitMissionServices from '../../../../services/fit-mission.services';
import { useParams } from 'react-router';
import numeral from 'numeral';

dayjs.locale('th');

const pageSize = 10;

const LegacyUserRewardPage = () => {
  const { rewardId } = useParams();
  const [searchText, setSearchText] = useState('');
  const [totalQuantity, setTotalQuantity] = useState(0);

  const {
    data: userRewardLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();

  fitMissionServices.useQueryGetMissionUserRewards(
    { take: pageSize, page, searchText, missionRewardId: rewardId },
    (data) => {
      setData(data.data);
      setTotal(data.meta.total);
      setTotalQuantity(data.meta.totalQuantity);
    },
  );

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      render: (_, record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: 'รหัส',
      dataIndex: 'memberCode',
      key: 'memberCode',
      render: (_, record) => (
        <span>{record.missionUser?.memberCode || '-'}</span>
      ),
    },
    {
      title: 'ชื่อ-สกุล',
      dataIndex: 'name',
      key: 'name',
      width: 250,
      render: (_, record) => {
        const user = record.missionUser?.user;
        const partner = record.missionUser?.partner;
        if (!user) return '-';
        if (partner) {
          return (
            <div style={{ lineHeight: 1.4 }}>
              <div>
                {user.FirstNameTh} {user.SurNameTh}
              </div>
              <div style={{ color: '#888', fontSize: '0.9em' }}>
                {partner.FirstNameTh} {partner.SurNameTh}
              </div>
            </div>
          );
        }
        return (
          <span>
            {user.FirstNameTh} {user.SurNameTh}
          </span>
        );
      },
    },
    {
      title: 'ทีม',
      dataIndex: 'team',
      key: 'team',
      render: (_, record) => {
        const user = record.missionUser?.user;
        if (!user) return '-';
        return <span>{user.TeamName || '-'}</span>;
      },
    },
    {
      title: 'วันที่กดรับรางวัล',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record) => (
        <span>{dayjs(record.createdAt).format('DD/MM/YYYY HH:mm')}</span>
      ),
      sorter: (a, b) =>
        dayjs(a.createdAt).diff(dayjs(b.createdAt), 'D') > 0 ? 1 : -1,
    },
  ];

  return (
    <Panel>
      <PanelHeader>ประวัติการรับรางวัล</PanelHeader>
      <PanelBody>
        <div style={{ display: 'flex', alignItems: 'center' }} className="mb-2">
          <Input
            placeholder="ค้นหารหัส, ชื่อ, สกุล"
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
            style={{ width: 300 }}
            allowClear
          />
          <div
            style={{
              backgroundColor: '#cfe2f3',
              borderRadius: 5,
              padding: 10,
              marginLeft: 16,
              border: '1px solid #6fa8dc',
              width: 200,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Typography.Text>
              จำนวนแลกทั้งหมด: {numeral(totalQuantity).format('0')}
            </Typography.Text>
          </div>
        </div>
        <Table
          columns={columns}
          dataSource={userRewardLists}
          style={{ backgroundColor: '#fff' }}
          rowKey="id"
          scroll={{ x: 'max-content' }}
          onChange={({ current }) => {
            setPage(current);
          }}
          pagination={{
            pageSize,
            total,
          }}
        />
      </PanelBody>
    </Panel>
  );
};

export default LegacyUserRewardPage;
